import { IPoiItem } from '../models/IPoiItem';

export const ALL_LOCATIONS_FILTER_RESET = 'All Locations';

export const getAllTerminalLocationItems = (poiData: IPoiItem[]) => {
	const terminals = poiData
		.map((poi) => poi.terminal)
		.filter((terminal) => terminal !== null);
	const uniqueTerminals = Array.from(new Set(terminals)) as string[];
	const sortedUniqueTerminals = uniqueTerminals.sort((a, b) =>
		a.localeCompare(b),
	);
	return [ALL_LOCATIONS_FILTER_RESET, ...sortedUniqueTerminals];
};
